import { render } from "./DataHasilAssesment.vue?vue&type=template&id=672e038c"
import script from "./DataHasilAssesment.vue?vue&type=script&lang=js"
export * from "./DataHasilAssesment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__